import { z } from "zod";

export const getVehicleLocationsPayloadSchema = z.object({
  vehicleUuid: z.uuid(),
  date: z.iso.datetime(),
});

export type GetVehicleLocationsPayload = z.infer<
  typeof getVehicleLocationsPayloadSchema
>;
